import { useEffect, useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { noPaginationParams } from '@/common/constants'
import useFetchPolicyRules from '@/common/hooks/useFetchPolicyRules/useFetchPolicyRules'
import { exceptionsStatus } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/ExceptionsConfiguration/ExceptionsList/constants'
import configurationServices from '@/configuration/services/services'

import { pageSize } from './constants'

const useExceptions = storeId => {
  const {
    data: exceptions,
    fetchData,
    loading,
  } = useFetch(configurationServices.getAllowList, { doInitialRequest: false })
  const { policyRulesData, gettingPolicyRules } = useFetchPolicyRules({
    doInitialRequest: true,
    params: { storeId, active: true, ...noPaginationParams },
  })
  const { fetchData: deleteException, loading: deletingException } = useFetch(configurationServices.deleteException, {
    doInitialRequest: false,
  })
  const { fetchData: toggleException, loading: togglingException } = useFetch(configurationServices.toggleException, {
    doInitialRequest: false,
  })
  const [currentPage, setCurrentPage] = useState(1)
  const [statusTab, setStatusTab] = useState(exceptionsStatus.active)
  const [search, setSearch] = useState('')

  useEffect(() => {
    fetchData({ page: currentPage, pageSize, status: statusTab, storeId, search: search })
  }, [currentPage, statusTab, storeId, fetchData, search])

  const refetchData = () => {
    if (currentPage === 1 || exceptions?.length > 1) {
      fetchData({ page: currentPage, pageSize, storeId, status: statusTab, search: search })
    } else {
      setCurrentPage(currentPage - 1)
    }
  }

  return {
    exceptions,
    totalPages: Math.ceil(exceptions?.count / pageSize),
    policyRules: policyRulesData?.results,
    gettingPolicyRules,
    refetchData,
    loading,
    currentPage,
    setCurrentPage,
    deleteException,
    deletingException,
    toggleException,
    togglingException,
    statusTab,
    setStatusTab,
    setSearch,
  }
}

export default useExceptions
